import { type ReactNode } from 'react';

import LocalizationSelect from './lang/LocalizationSelect';

import styles from './Layout.module.scss';

const Layout = ({ children }: { children: ReactNode }) => (
  <div className={styles.wrapper}>
    <div className={styles.outerContainer}>
      <header className={styles.header}>
        <a href="https://clearvpn.com/">
          <img
            src="/images/logo-horizontal-white.png"
            srcSet="/images/logo-horizontal-white@2x.png 2x"
            width="112"
            height="32"
            alt="ClearVPN"
          />
        </a>

        <LocalizationSelect />
      </header>
      {children}
    </div>
  </div>
);

export default Layout;
